import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi, ExamBlockPlaceHolder, NodePOSTApiAuth } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';
import NotFound from '../../NotFound';
import Chapters from './Chapters';
import UploadAnswer from './UploadAnswer';

const slug = {
  "ubt": "UBT",
  "cbt-chemical": "CBT CHEMICAL",
  "cbt-electronics-electricity": "CBT ELECTRONIC ELECTRCITY",
  "cbt-food-related": "CBT FOOD RELATED",
  "cbt-mechinery-molding": "CBT MACHINERY,MOLDING",
  "cbt-metal": "CBT METAL",
  "cbt-pulp-paper-wood": "CBT PULP PAPER WOOD",
  "cbt-rubber": "CBT RUBBER",
  "cbt-textile-sewing": "CBT TEXTILE SEWING"
}
export default function StartCourse() {
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [AllExamListUnavailable, setAllExamListUnavailable] = React.useState([]);
  const [reload, setReload] = React.useState(false)
  const [pagesLength, setPagesLength] = React.useState("1");
  const [pages, setPages] = React.useState(1);
  const dispatch = useDispatch()
  const [usersData, setUsersData] = React.useState({ meta: { number_of_exams: "0" } });
  const LoginState = useSelector((state) => state.LoginState);
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [courseData, setCourseData] = React.useState({});
  const [chapterData, setChapterData] = React.useState({ meta: {} });

  const location = useLocation()
  useEffect(() => {
    var slug = location.pathname.slice(slugs.start_course.length + 1);
    setExamFetch(false)
    setNotFound(false)
    setReload(true)

    NodePOSTApiAuth({
      userID: LoginState.userID,
      examSlug: slug
    }, "start-course-details")
      .then((response) => {
        if (response.data.error)
          setNotFound(true)
        else {
          // console.log(response.data.chapters)
          setCourseData(response.data.course[0])
          setChapterData(response.data.chapters)
          setAllExamList1(response.data.examData)
        }
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
      .finally(() => {
        setExamFetch(true)
        setReload(false)
      })
    console.log(slug)
  }, [])


  return (
    <div style={{ margin: "3px", backgroundColor: "#fff", minHeight: "95vh" }}>
      {ExamFetch &&
        <>
          {NotFoundData ?
            <NotFound /> :
            <>
              <div className="row">
                <div className="col-1"></div>
                <div className="col-10 form-view mt-3">

                  <div className="row" style={{ margin: "10px" }}>
                    <h2>Course Information</h2>
                    <div>Course Name: {courseData.title.rendered}</div>
                    {courseData.meta.zoom_link !== "" &&
                      <div style={{ width: "100%", display: 'flex', marginTop: "10px" }}>
                        <a className="Link" style={{ padding: "2px 10px", borderRadius: "10px", }}
                          href={courseData.meta.zoom_link}
                        >
                          <div style={{}}>
                            Join Live Class:
                            <div style={{}}>
                              <img style={{ border: "1px solid black", borderRadius: "10px", width: "100px", objectFit: "contain" }}
                                src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/Screenshot-2025-09-05-at-10.00.32.png'
                              />
                            </div>
                          </div>
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <Chapters
                ChapterData={chapterData}
                reload={reload}
                setReload={setReload}
              />

              {AllExamList1.length !== 0 &&
                <div style={{ marginVertical: 10 }}>
                  <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 form-view mt-3">
                      <div className="row" style={{ margin: "10px", }}>
                        <span>MCQs</span>
                        <div className='row'>
                          {AllExamList1.map((item, index) => (
                            <div key={index} className='col-md-3' >
                              <>

                                <ExamBlock item={item}
                                  examSlug={slugs.start_exam}
                                />
                                {/* {isEmulator ?
                          <ExamBlock item={item} db_slug={db_slug} result_slug={result_slug} navigation={navigation}
                            navigationTo={`${slugs.start_demo_exam}emu`} />
                          :
                          <ExamBlock item={item} db_slug={db_slug} result_slug={result_slug} navigation={navigation}
                            navigationTo={slugs.start_demo_exam} />
                        } */}
                              </>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

              {/* <div className="row">
                <div className="col-1"></div>
                <div className="col-10 form-view mt-3">
                  <UploadAnswer setReload={setReload} />
                </div>
              </div> */}
            </>
          }
        </>
      }
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}



const ExamBlock = ({ item, examSlug }) => {
  const location = useLocation();
  return (
    <div style={{
      margin: "5px 0px",
      border: "1.5px solid #bbb",
      borderRadius: "5px",
    }}>
      {/* {item.meta.featured_image !== "" ?
        <img className="col-12" src={item.meta.featured_image}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
        :
        <img className="col-12"
          src={ExamBlockPlaceHolder}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
      } */}
      <br />
      <Link className="col-8 Link"
        to={`${examSlug}/${item.slug}`}
      >
        <div style={{ fontWeight: "bold", textAlign: "center", fontSize: "18px" }}>
          {item.title.rendered}&nbsp;
        </div>
      </Link>

    </div >
  )

}